import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const WorksiteFormDefaultProps = {
  ...BaseDefaultProps,
  address: {},
  code: null,
  label: null,
  onSuccess: () => null,
  refetch: () => null,
  setShowForm: () => null,
};

export const WorksiteFormPropTypes = {
  ...BasePropTypes,
  address: PropTypes.shape({
    city: PropTypes.string,
    country: PropTypes.string,
    fax: PropTypes.string,
    name: PropTypes.string,
    phone1: PropTypes.string,
    phone2: PropTypes.string,
    postcode: PropTypes.string,
    street1: PropTypes.string,
    street2: PropTypes.string,
    street3: PropTypes.string,
  }),
  code: PropTypes.string,
  label: PropTypes.string,
  onSuccess: PropTypes.func,
  refetch: PropTypes.func,
  setShowForm: PropTypes.func,
};
